import remarkGemoji from 'remark-gemoji';

// @ts-ignore
function gemoji() {
    return {
        remark: (u) => u.use(remarkGemoji),
    };
}

export { gemoji as default };
//# sourceMappingURL=index.esm.js.map
